import smallScaleTaskTrace from './view/smallScaleTaskTrace.html'

export default {
  base: {
    state: 'declaration.addValTaxSmallScale.smallScaleTaskTrace',
    config: {
      url: '/smallScaleTaskTrace',
      abstract: true,
      template: '<div ui-view></div>',
      default: 'declaration.addValTaxSmallScale.smallScaleTaskTrace.list',
      title: '申报任务跟踪',
    },
  },
  list: {
    state: 'declaration.addValTaxSmallScale.smallScaleTaskTrace.list',
    config: {
      url: '/list',
      template: smallScaleTaskTrace,
      controller: 'smallScaleTaskTraceCtrl',
    },
  },
}



// WEBPACK FOOTER //
// ./src/app/declaration/addValTaxSmallScale/smallScaleTaskTrace/routers.js